import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminCourseAddLoader = async (args: LoaderFunctionArgs) => {

    const getEducationsResponse = await networkCall('/educations', { params: { userId: args.params.id } });

    return { getEducationsResponse, userId: args.params.id };

};